import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import type { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import type { Observable } from 'rxjs';
import { of } from 'rxjs';
import { catchError, concatMap } from 'rxjs/operators';

import type { IPage } from 'components/organisms/widgets-loader/entities/types';
import { WidgetsService } from 'components/organisms/widgets-loader/widgets.service';
import { WIDGETS_CONFIG } from 'components/widgets/widgets-config';

const QAA_STUB_URL = '/qaa-stub/';
const LOCAL_QAA_STUB_URL = '/assets/qaa-stub/index.json';

@Injectable()
export class QaaViewResolverService {
    private readonly platformId = inject(PLATFORM_ID);
    private readonly httpClient = inject(HttpClient);
    private readonly widgetsService = inject(WidgetsService);

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        if (isPlatformBrowser(this.platformId)) {
            return this.httpClient.get<IPage | null>(QAA_STUB_URL).pipe(
                catchError(() => this.httpClient.get<IPage | null>(LOCAL_QAA_STUB_URL)),
                catchError(() => of(null)),
                concatMap((data) =>
                    data ? this.widgetsService.resolveWidgetsFromPage(data, WIDGETS_CONFIG) : of(null)
                )
            );
        }

        return of(null);
    }
}
